import React from 'react';
import { motion } from 'framer-motion';
import { snak2Images, windowOfOpportunity, windowStages } from '../../../data/snak2';
const EASE = [0.23, 1, 0.32, 1] as const;
export function WindowScreen() {
  return <div className="flex flex-1 flex-col" data-id="element-720" data-mp="2ro42avw73lrk">
      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.28,
      ease: EASE
    }} className="relative overflow-hidden rounded-xl" data-id="element-721" data-mp="2rn2q2o3g0t89">
        <img src={snak2Images.window.src} alt={snak2Images.window.alt} draggable={false} className="h-[112px] w-full select-none object-cover" data-id="element-722" data-mp="2im4kw2h9qfo3" />
        <figcaption className="absolute inset-x-0 bottom-0 bg-ozNavy/85 px-3 py-1.5 text-[9px] uppercase tracking-micro text-paper" data-id="element-723" data-mp="28se0b8o9ipdo">
          {windowOfOpportunity.eyebrow}
        </figcaption>
      </motion.figure>

      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.06,
      ease: EASE
    }} className="mt-4 font-display text-[27px] font-semibold leading-[1.06] tracking-tight text-ozNavy" data-id="element-724" data-mp="1ztzbhtil6qs">
        {windowOfOpportunity.headline[0]}
        <br data-id="element-725" data-mp="vxudw7dz1q51" />
        {windowOfOpportunity.headline[1]}
      </motion.h2>

      <p className="mt-3.5 text-[12.5px] leading-relaxed text-mut" data-id="element-726" data-mp="vzp0rr8szsbr">{windowOfOpportunity.lead}</p>

      <p className="mt-5 text-[9px] uppercase tracking-micro text-mut" data-id="element-727" data-mp="10y8mbqjhj23l">
        {windowOfOpportunity.scaleLabel}
      </p>

      <ol className="mt-2.5 flex flex-col gap-2" data-id="element-728" data-mp="1tlmc94ormxe7">
        {windowStages.map((stage, i) => <motion.li key={stage.label} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.24,
        delay: 0.12 + i * 0.06,
        ease: EASE
      }} data-id="element-729" data-mp="1ewgd1gpxh76b" data-mpi={i}>
            <div className="flex items-baseline justify-between gap-3" data-id="element-730" data-mp="27jt0ru7trl17">
              <p className="text-[12px] font-semibold leading-snug text-ozNavy" data-id="element-731" data-mp="2cc41v0eaxcvc">{stage.label}</p>
              <p className="shrink-0 text-[9.5px] tabular-nums text-mut" data-id="element-732" data-mp="2m7b1yim6hxiv">{stage.integrity}%</p>
            </div>
            <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-ozMist" data-id="element-733" data-mp="2h883jh0pepjv">
              <motion.div initial={{
            scaleX: 0
          }} animate={{
            scaleX: stage.integrity / 100
          }} transition={{
            duration: 0.28,
            delay: 0.18 + i * 0.06,
            ease: EASE
          }} style={{
            transformOrigin: 'left'
          }} className={`h-full ${stage.integrity < 60 ? 'bg-ozBlue' : 'bg-ozGreen'}`} data-id="element-734" data-mp="2d6d3efuiei7o" />
            </div>
            <p className="mt-1 text-[10.5px] leading-snug text-mut" data-id="element-735" data-mp="1tivo3zes9l94">
              {stage.structure} · <span className="text-ozBlue" data-id="element-736" data-mp="1phad6jlt7h1k">{stage.functionNote}</span>
            </p>
          </motion.li>)}
      </ol>

      <p className="mt-2.5 text-[9px] leading-snug text-mut" data-id="element-737" data-mp="1kiqsemiycbas">{windowOfOpportunity.scaleNote}</p>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.44,
      ease: EASE
    }} className="mt-auto pt-5 font-display text-[21px] font-semibold leading-snug text-ozNavy" data-id="element-738" data-mp="1fikw2t1qm0md">
        {windowOfOpportunity.takeaway}
      </motion.p>
    </div>;
}